<template>
  <header class="header">
    <div class="header-container">
      <div class="logo">
        <router-link :to="{ name: 'Home' }">
          <img src="@/assets/logo.png" alt="logo" class="logo-img" />
        </router-link>
      </div>
      <nav class="nav">
        <ul>
          <li><router-link :to="{ name: 'Home' }" exact-active-class="active">首页</router-link></li>
          <li><router-link :to="{ name: 'Products' }" active-class="active">产品中心</router-link></li>
          <li><router-link :to="{ name: 'About' }" active-class="active">关于我们</router-link></li>
          <li><router-link :to="{ name: 'Articles' }" active-class="active">推荐文章</router-link></li>
        </ul>
      </nav>
      <div class="search">
        <input 
          type="text" 
          placeholder="输入药品名称、厂家或批准文号搜索" 
          v-model="searchKeyword" 
          @keyup.enter="searchMedicine"
        />
        <button type="button" @click="searchMedicine">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
          搜索
        </button>
        
        <!-- 搜索结果下拉框 -->
        <div class="search-results" v-if="showResults">
          <div v-if="loading" class="loading-results">
            <span>搜索中...</span>
          </div>
          <div v-else-if="error" class="error-results">
            <span>{{ error }}</span>
          </div>
          <div v-else-if="searchResults.length === 0" class="empty-results">
            <span>未找到相关药品</span>
          </div>
          <ul v-else>
            <li v-for="item in searchResults" :key="item.id" @click="goToDetail(item.id)">
              <div class="search-item">
                <div class="search-item-image">
                  <img :src="item.image || defaultImage" :alt="item.name" />
                </div>
                <div class="search-item-info">
                  <div class="search-item-name">{{ item.name }}</div>
                  <div class="search-item-manufacturer">{{ item.manufacturer }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { searchMedicineAPI } from '@/api/config';

export default {
  name: 'TheHeader',
  data() {
    return {
      searchKeyword: '',
      searchResults: [],
      showResults: false,
      loading: false,
      error: null,
      defaultImage: 'https://via.placeholder.com/50x50?text=药品'
    };
  },
  methods: {
    async searchMedicine() {
      // 如果搜索关键词为空，不执行搜索
      if (!this.searchKeyword.trim()) {
        this.error = '请输入搜索关键词';
        this.showResults = true;
        return;
      }
      
      this.loading = true;
      this.error = null;
      this.showResults = true;
      
      try {
        const response = await searchMedicineAPI(this.searchKeyword);
        
        if (response.code === 1) {
          this.searchResults = response.data.data;
        } else {
          this.error = response.msg;
          this.searchResults = [];
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.error = '搜索失败，请稍后重试';
        this.searchResults = [];
      } finally {
        this.loading = false;
      }
    },
    
    goToDetail(id) {
      // 跳转到药品详情页
      this.$router.push({ name: 'ProductDetail', params: { id } });
      // 关闭搜索结果
      this.showResults = false;
    },
    
    handleClickOutside(event) {
      const searchElement = this.$el.querySelector('.search');
      if (searchElement && !searchElement.contains(event.target)) {
        this.showResults = false;
      }
    }
  },
  mounted() {
    // 添加点击外部关闭搜索结果的事件监听
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
/* 顶部导航组件样式 */
.header {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px 10px 20px;
}

.logo h1 {
  font-size: 1.8rem;
  color: #3a8ee6;
  margin: 0;
}

.logo-img {
  height: 48px;
  width: auto;
  display: block;
  filter: drop-shadow(0 2px 6px rgba(58,142,230,0.12));
}

.nav ul {
  display: flex;
  list-style-type: none;
  gap: 36px;
}

.nav li {
  position: relative;
}

.nav a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 1.05rem;
  padding: 6px 0;
  position: relative;
  transition: color 0.3s;
  letter-spacing: 0.2px;
}

.nav a:hover, .nav a.active {
  color: #007AFF;
}

.nav a.active:after, .nav a:hover:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: #007AFF;
  border-radius: 1px;
  transition: all 0.3s;
}

.nav a:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffe082 0%, #42b983 100%);
  border-radius: 2px;
  transition: all 0.3s;
}

.search {
  display: flex;
  position: relative;
  align-items: center;
  background: rgba(255,255,255,0.8);
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 3px 6px 3px 12px;
  transition: box-shadow 0.3s, background 0.3s;
  border: 1px solid rgba(255,255,255,0.5);
}

.search input {
  padding: 10px 15px;
  border: none;
  border-radius: 8px;
  outline: none;
  width: 240px;
  font-size: 0.95rem;
  background: rgba(255,255,255,0.7);
  box-shadow: none;
  transition: all 0.3s;
  color: #333;
}

.search input:focus {
  background: #fff;
  box-shadow: 0 0 0 3px rgba(0,122,255,0.2);
}

.search button {
  background: #007AFF;
  color: white;
  border: none;
  padding: 0 22px 0 18px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  margin-left: 8px;
  box-shadow: 0 2px 8px rgba(0,122,255,0.2);
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;
  height: 40px;
}

.search button:hover {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 6px 18px rgba(255,255,255,0.25);
  text-shadow: 0 0 8px rgba(255,255,255,0.7);
}

.search svg {
  width: 20px;
  height: 20px;
  fill: #ffffff;
  transition: all 0.3s;
  filter: drop-shadow(0 0 2px rgba(255,255,255,0.3));
}

.search button:hover svg {
  fill: #ffffff;
  filter: drop-shadow(0 0 4px rgba(255,255,255,0.7));
}

@keyframes shine {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* 搜索结果样式 */
.search-results {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  background-color: rgba(255,255,255,0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  margin-top: 5px;
  z-index: 1010;
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid rgba(255,255,255,0.5);
}

.search-results ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.search-results li {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-results li:last-child {
  border-bottom: none;
}

.search-results li:hover {
  background-color: #f5f7fa;
}

.search-item {
  display: flex;
  align-items: center;
}

.search-item-image {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f7ff;
}

.search-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.search-item-info {
  flex: 1;
}

.search-item-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
}

.search-item-manufacturer {
  font-size: 0.85rem;
  color: #999;
}

.loading-results,
.error-results,
.empty-results {
  padding: 20px;
  text-align: center;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    padding: 10px;
  }
  
  .nav {
    margin: 15px 0;
  }
  
  .nav ul {
    flex-wrap: wrap;
    justify-content: center;
    gap: 18px;
  }
  
  .search {
    width: 100%;
    margin-top: 15px;
  }
  
  .search input {
    flex: 1;
  }
}

.logo {
  display: flex;
  align-items: center;
}
</style> 